import React from 'react';
import PropTypes from 'prop-types';

import SocialShareUrl from './SocialShareUrl';
import withModal from '../modal/withModal';

export const SOCIAL_SHARE_URL_MODAL = 'modal/SOCIAL_SHARE_URL';

const propTypes = {
  actionProps: PropTypes.shape({
    content: PropTypes.any,
    url: PropTypes.string,
    hashtag: PropTypes.string,
  }),
  onRequestClose: PropTypes.func,
};

const SocialShareUrlContainer = ({
  actionProps: { ...props } = {},
  onRequestClose,
}) => {
  return <SocialShareUrl onClose={onRequestClose} {...props} />;
};

SocialShareUrlContainer.propTypes = propTypes;

export default withModal(SocialShareUrlContainer, {
  name: SOCIAL_SHARE_URL_MODAL,
  dismissible: false,
  size: 'sm',
  overlayClassName: 'purchase-success-referral-modal-overlay',
});
